import styled from 'styled-components';

const Title = styled.h3`
  margin: 0;
`;

export default {
  Title,
};